/**
 * @param data The data to be parsed
 * @param fallback The fallback value to return if data is undefined or null
 * @returns a parsed object of type T
 */
export function parseJson<T>(data: string | undefined, fallback: T): T {
	try {
		if (!data || data === 'null') {
			return fallback;
		}
		return JSON.parse(data);
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
	} catch (e) {
		return fallback;
	}
}
